module.exports = __webpack_public_path__ + "static/img/Jacob-Saifiti.2033803.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jacob-Saifiti.jpg
// module id = CNC5
// module chunks = 0